import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class API_overview extends PureComponent {
  render() {
    return (
      <div className="row" id="api_overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>API Overview</h2>
              <p>
                Nexoid uses a REST API to allow developers to use HTTP requests
                to <span className="methodCodeGET fs16">GET</span>,{" "}
                <span className="methodCodePUT fs16">PUT</span>,{" "}
                <span className="methodCodePOST fs16">POST</span>,{" "}
                <span className="methodCodePATCH fs16">PATCH</span>, and{" "}
                <span className="methodCodeDELETE fs16">DELETE </span> data.
                Nexoid API uses the JSON standard for HTTP requests and
                responses.
              </p>
              <p>
                Nexoid API is a business function layer on top of ElasticSearch,
                giving us the incredible speed and scalability not seen in other
                technologies. Indexes or tables for those of you used to
                traditional SQL databases are generated automatically through
                Nexoid API. The first record is used to interpret data types of
                a new index (table). To reduce incorrect data type
                classifications stick to the field naming conventions outlined
                in the overview. Queries use the ElasticSearch syntax so for
                advanced search queries feel free to use the ElasticSearch 6.X
                documentation.
              </p>
              <p>
                Nexoid API automatically records who creates and updates a
                record with a "created by" and "updated by" object in the
                record. Nexoid API also creates detailed audit logs recording
                create, read, write, delete and search. Security and permissions
                are managed at an object level or an individual record level
                with RLP groups. For more information, look at{" "}
                <PageLink
                  to="/Security#security_overview"
                  text="Security and Permissions"
                />
                .
              </p>
              <p>
                Nexoid customers are assigned a shared regional API cluster.
                Each API cluster has a unique API URLs. In this document, we
                have always referred to The API URL as example.api.nexoid.com.
                Where in reality, yours is a region followed by a number like{" "}
                <strong>ie23</strong>.api.nexoid.com (Ireland Cluster 23).
              </p>
              <p>
                Nexoid is designed around keeping all client data in one
                geographical region. You choose this region upon registration.
                There is no way to change a customers region. The only option is
                to create a new customer account in the new region and import
                the data from the old region.
              </p>
              <p>
                Before you start, go to{" "}
                <PageLink to="/api#url" text="Getting Started - Get API URL" />{" "}
                and get your Customer API URL and Customer ID. Then go to{" "}
                <PageLink to="/api#sign_in" text="Authentication - Sign In" />{" "}
                to get a Session ID.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol"></div>
      </div>
    );
  }
}

export default API_overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/API_overview.js